/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer components {
  .hideArrow {
    :global(.ant-tooltip-arrow) {
      display: none;
    }
  }
}
